import { postServer } from "../services/post-server.ts";
import { CreatePostRequest, UpdatePostRequest, PostResponse, PostDetailResponse } from "../entry/server/post.ts";

export const postRepo = {
    createPost: async (post: CreatePostRequest) => {
        return await postServer.createPost(post);
    },
    updatePost: async (id: number, post: UpdatePostRequest) => {
        return await postServer.updatePost(id, post);
    },
    getPosts: async (page: number) => {
        return await postServer.getPosts(page);
    },
    getPost: async (id: number) => {
        return await postServer.getPost(id);
    },
    deletePost: async (id: number) => {
        return await postServer.deletePost(id);
    },
}